export default __webpack_public_path__ + "static/media/grafema_ciceco_03.45877479.jpg";